const tableAttributes = [
    {
        name: 'shareName',
        sortable: true,
        sortBy: 'shareName',
        label: 'SharedName',
        moreInfoIcon: true,
        hideValue: 'true',
        isHeader: true,
        showInCard: false,

        component: {
            componentName: 'HighlightedClickableLabel',
            queryParam: 'sharedFolderId',
        },
        styles: {
            color: '#282828',
            fontSize: '13px',
            fontWeight: 'bold',
        },
        //NOTE : Keeping the commented out code for subcomponent traceability
        // requireAccess: {
        //     control:
        //         'ResourceAdmin-SharedFolders-List-SharedName',
        // },
    },

    {
        name: 'uncPath',
        sortable: true,
        sortBy: 'uncPath',
        label: 'UNCPath',

        headerCellStyles: {},
        styles: {
            fontSize: '13px',
        },
        requireAccess: {
            control: 'ResourceAdmin-SharedFolders-List-UNCPath',
        },
    },
    {
        hideValue: true,
        showInCard: false,
        component: {
            componentName: 'actionButtons',
        },
        requireAccess: {
            control: 'ResourceAdmin-SharedFolders-List-Actions',
        },
    },
]

//TODO: Add detail page attributes once detail page is ready
const detailAttributes = [
    {
        label: 'FriendlyName',
        value: 'friendlyName',
        firstPane: true,
    },
    {
        label: 'Computer',
        value: 'computerFriendlyName',
        firstPane: true,
    },
    {
        label: 'UNCPath',
        value: 'uncPath',
        firstPane: true,
    },
    {
        label: 'SharedName',
        value: 'shareName',
        firstPane: true,
    },
    {
        label: 'DNSHostName',
        value: 'dnsHostName',
        firstPane: true,
    },
    {
        label: 'LocalPath',
        value: 'localPath',
        firstPane: true,
    },
    {
        label: 'DFSPath',
        value: 'dfsPath',
        firstPane: true,
    },
    {
        label: 'ResourceSystem',
        value: 'resourceSystemFriendlyName',
    },
    {
        label: 'CreatedDate',
        value: 'createdDateUtc',
        name: 'createdDateUtc',
        hideValue: true,
        component: {
            componentName: 'DateTimeGenericComponent',
        },
    },
    {
        label: 'ModifiedDate',
        value: 'modifiedDateUtc',
        name: 'modifiedDateUtc',
        hideValue: true,
        component: {
            componentName: 'DateTimeGenericComponent',
        },
    },
    {
        label: 'Description',
        value: 'description',
    },
]

const accessRequestAttributes = {
    general: [
        {
            labelKey: 'FriendlyName',
            value: 'friendlyName',
        },
        {
            labelKey: 'DisplayName',
            value: 'name',
        },
        {
            labelKey: 'Description',
            value: 'description',
        },
        {
            labelKey: 'AllowAccessRequests',
            value: 'isRequestAllowed',
        },
        {
            labelKey: 'ApprovalPolicy',
            value: 'approvalPolicy',
        },
        {
            labelKey: 'FullfillmentDelay(Hrs)',
            value: 'delay',
        },
    ],
    timeRestriction: [
        {
            labelKey: 'TimeRestrictAccess',
            value: 'isTimeConstrained',
        },
        {
            labelKey: 'DefaultAccessDuration(Min)',
            value: 'defaultValueInMinutes',
        },
        {
            labelKey: 'MaxDuration(Min)',
            value: 'maximumValueInMinutes',
        },
        {
            labelKey: 'AllowDurationSelection',
            value: 'isDurationSelectable',
        },
    ],
}

const attributes = {
    tableAttributes,
    detailAttributes,
    accessRequestAttributes,
}

export default attributes
